import { getWidthByHeight } from '../../util/image/pickImageByRatio';
import { useCategoryTreeItem } from '../categoryTree';
import { tvpil } from '../compat/tvpil';

export function useGridImageSettings(referenceId: string) {
  const category = useCategoryTreeItem(referenceId);

  if (!category) {
    return undefined;
  }

  const imageType = category.railImageProperty?.assetPresentationImageType;
  const imageRatio = tvpil.imageTypes.find((type) => type.id === imageType)?.ratio;
  const imageHeight = category.imageScreens.imageHeight;
  const imageHeightCompact = category.imageScreens.imageHeightCompact;
  const imageHeightMedium = category.imageScreens.imageHeightMedium;
  const imageWidth = imageRatio ? getWidthByHeight(imageHeight, imageRatio) : undefined;
  const imageWidthCompact = imageRatio ? getWidthByHeight(imageHeightCompact, imageRatio) : undefined;
  const imageWidthMedium = imageRatio ? getWidthByHeight(imageHeightMedium, imageRatio) : undefined;

  return {
    imageType,
    imageRatio,
    imageHeight,
    imageHeightCompact,
    imageHeightMedium,
    imageWidth,
    imageWidthCompact,
    imageWidthMedium,
  };
}

export type GridImageSettings = NonNullable<ReturnType<typeof useGridImageSettings>>;
